export default "__VITE_ASSET__DiVS_9Gs__"